import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      DONE: "Suksess",
      YOUR_DELIVERIES_ARE_PAUSED_BETWEEN: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Dine leveranser er satt på pause mellom ${firstDateString} og ${lastDateString}`,
      YOU_WILL_NOT_RECEIVE_DELIVERIES_IN_THIS_PERIOD:
        "Du vil ikke motta noen levering i denne perioden hvis du ikke bestiller individuelle leveranser. Velkommen tilbake snart!",
      TO_MY_ACCOUNT: "Til min konto",

      DO_YOU_REGRET: "Angrer du?",
      YOU_CAN_QUICKLY_RESUME_YOUR_DELIVERIES:
        "Du kan raskt starte dine leveranser igjen, når du vil og uten bindingstid!",
      RESUME: "Gjenoppta leveranser",
    },

    se: {
      DONE: "Klart",
      YOUR_DELIVERIES_ARE_PAUSED_BETWEEN: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Dina leveranser är pausade mellan ${firstDateString} och ${lastDateString}`,
      YOU_WILL_NOT_RECEIVE_DELIVERIES_IN_THIS_PERIOD:
        "Du kommer inte att få någon leverans under denna period om du inte beställer enskilda leveranser. Välkommen tillbaka snart!",

      DO_YOU_REGRET: "Ångrar du dig?",
      YOU_CAN_QUICKLY_RESUME_YOUR_DELIVERIES:
        "Du kan snabbt starta dina leveranser igen, när du vill och utan bindningstid!",
      TO_MY_ACCOUNT: "Till mitt konto",

      RESUME: "Återuppta leveranser",
    },

    dk: {
      DONE: "Færdig!",
      YOUR_DELIVERIES_ARE_PAUSED_BETWEEN: ({
        firstDateString,
        lastDateString,
      }: {
        firstDateString: string;
        lastDateString: string;
      }) =>
        `Dine leveringer er stoppet mellem ${firstDateString} og ${lastDateString}`,
      YOU_WILL_NOT_RECEIVE_DELIVERIES_IN_THIS_PERIOD:
        "Du modtager ingen levering i denne periode, hvis du ikke bestiller enkeltleverancer. Velkommen tilbage snart!",
      TO_MY_ACCOUNT: "Til min konto",

      DO_YOU_REGRET: "Fortryder du?",
      YOU_CAN_QUICKLY_RESUME_YOUR_DELIVERIES:
        "Genaktivér dit abonnement - helt uden binding!",
      RESUME: "Genaktivér",
    },
  } as const
)[language];
